import { render } from "./deleteAccountComponent.vue?vue&type=template&id=d09b7686"
import script from "./deleteAccountComponent.vue?vue&type=script&lang=js"
export * from "./deleteAccountComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__